var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
import { truncateStyle } from '../../../../styles/customCSS';
var buttonStyles = {
    root: function (_a) {
        var props = _a.props, variables = _a.variables;
        var circular = props.circular, disabled = props.disabled, fluid = props.fluid, primary = props.primary, text = props.text, iconOnly = props.iconOnly, isFromKeyboard = props.isFromKeyboard;
        var height = variables.height, minWidth = variables.minWidth, maxWidth = variables.maxWidth, borderRadius = variables.borderRadius, circularRadius = variables.circularRadius, paddingLeftRightValue = variables.paddingLeftRightValue, color = variables.color, colorActive = variables.colorActive, colorHover = variables.colorHover, colorFocus = variables.colorFocus, colorDisabled = variables.colorDisabled, backgroundColor = variables.backgroundColor, backgroundColorActive = variables.backgroundColorActive, backgroundColorHover = variables.backgroundColorHover, backgroundColorFocus = variables.backgroundColorFocus, backgroundColorDisabled = variables.backgroundColorDisabled, borderColor = variables.borderColor, borderColorActive = variables.borderColorActive, borderColorHover = variables.borderColorHover, borderColorFocus = variables.borderColorFocus, borderColorFocusIndicator = variables.borderColorFocusIndicator, borderColorDisabled = variables.borderColorDisabled, borderWidth = variables.borderWidth, primaryColor = variables.primaryColor, primaryColorActive = variables.primaryColorActive, primaryColorHover = variables.primaryColorHover, primaryColorFocus = variables.primaryColorFocus, primaryBackgroundColor = variables.primaryBackgroundColor, primaryBackgroundColorActive = variables.primaryBackgroundColorActive, primaryBackgroundColorHover = variables.primaryBackgroundColorHover, primaryBackgroundColorFocus = variables.primaryBackgroundColorFocus, primaryBorderColor = variables.primaryBorderColor, primaryBorderColorActive = variables.primaryBorderColorActive, primaryBorderColorHover = variables.primaryBorderColorHover, primaryBorderColorFocus = variables.primaryBorderColorFocus, primaryBorderColorFocusIndicator = variables.primaryBorderColorFocusIndicator, primaryBorderWidth = variables.primaryBorderWidth, primaryCircularBorderColorFocusIndicator = variables.primaryCircularBorderColorFocusIndicator, circularColor = variables.circularColor, circularColorActive = variables.circularColorActive, circularBackgroundColor = variables.circularBackgroundColor, circularBackgroundColorActive = variables.circularBackgroundColorActive, circularBackgroundColorHover = variables.circularBackgroundColorHover, circularBackgroundColorFocus = variables.circularBackgroundColorFocus, circularBorderColor = variables.circularBorderColor, circularBorderColorActive = variables.circularBorderColorActive, circularBorderColorHover = variables.circularBorderColorHover, circularBorderColorFocus = variables.circularBorderColorFocus, circularBorderColorFocusIndicator = variables.circularBorderColorFocusIndicator, textColor = variables.textColor, textColorHover = variables.textColorHover, textPrimaryColor = variables.textPrimaryColor, textPrimaryColorHover = variables.textPrimaryColorHover, boxShadow = variables.boxShadow;
        return __assign({ height: height,
            minWidth: minWidth,
            maxWidth: maxWidth,
            color: color,
            backgroundColor: backgroundColor,
            borderRadius: borderRadius, display: 'inline-flex', justifyContent: 'center', alignItems: 'center', position: 'relative', padding: "0 " + pxToRem(paddingLeftRightValue), margin: "0 " + pxToRem(8) + " 0 0", verticalAlign: 'middle', cursor: 'pointer' }, (!text && __assign({ outline: 0, borderRadius: '2px', borderWidth: "" + pxToRem(borderWidth), borderStyle: 'solid', borderColor: borderColor,
            boxShadow: boxShadow, ':hover': {
                color: colorHover,
                backgroundColor: backgroundColorHover,
                borderColor: borderColorHover,
            } }, (isFromKeyboard && {
            ':focus': {
                color: colorFocus,
                backgroundColor: backgroundColorFocus,
                borderColor: borderColorFocus,
                ':after': {
                    content: '""',
                    position: 'absolute',
                    top: "-" + pxToRem(borderWidth * 2),
                    right: "-" + pxToRem(borderWidth * 2),
                    bottom: "-" + pxToRem(borderWidth * 2),
                    left: "-" + pxToRem(borderWidth * 2),
                    borderWidth: "" + pxToRem(borderWidth),
                    borderStyle: 'solid',
                    borderColor: "" + borderColorFocusIndicator,
                    borderRadius: '3px',
                },
            },
        }), (!isFromKeyboard && {
            ':focus': {
                ':active': {
                    color: colorActive,
                    backgroundColor: backgroundColorActive,
                    borderColor: borderColorActive,
                    boxShadow: 'none',
                },
            },
        }))), (circular &&
            !text && __assign({ minWidth: height, padding: 0, color: circularColor, backgroundColor: circularBackgroundColor, borderColor: circularBorderColor, borderRadius: circularRadius, ':hover': {
                color: circularColorActive,
                backgroundColor: circularBackgroundColorHover,
                borderColor: circularBorderColorHover,
            } }, (isFromKeyboard && {
            ':focus': {
                color: circularColorActive,
                backgroundColor: circularBackgroundColorFocus,
                borderColor: circularBorderColorFocus,
                ':after': {
                    content: '""',
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    bottom: '0',
                    left: '0',
                    borderWidth: "" + pxToRem(borderWidth),
                    borderStyle: 'solid',
                    borderColor: "" + circularBorderColorFocusIndicator,
                    borderRadius: circularRadius,
                },
            },
        }), (!isFromKeyboard && {
            ':focus': {
                ':active': {
                    color: circularColorActive,
                    backgroundColor: circularBackgroundColorActive,
                    borderColor: circularBorderColorActive,
                    boxShadow: 'none',
                },
            },
        }))), (text && __assign({ color: textColor, backgroundColor: 'transparent', borderColor: 'transparent', ':hover': {
                color: textColorHover,
            } }, (primary && {
            color: textPrimaryColor,
            ':hover': {
                color: textPrimaryColorHover,
            },
        }))), (primary &&
            !text && __assign({ color: primaryColor, backgroundColor: primaryBackgroundColor, borderWidth: "" + pxToRem(primaryBorderWidth), borderStyle: 'solid', borderColor: "" + primaryBorderColor, ':hover': {
                color: primaryColorHover,
                backgroundColor: primaryBackgroundColorHover,
                borderColor: primaryBorderColorHover,
            } }, (isFromKeyboard &&
            !circular && {
            ':focus': {
                color: primaryColorFocus,
                backgroundColor: primaryBackgroundColorFocus,
                borderColor: primaryBorderColorFocus,
                ':after': {
                    content: '""',
                    position: 'absolute',
                    top: "-" + pxToRem(primaryBorderWidth * 2),
                    right: "-" + pxToRem(primaryBorderWidth * 2),
                    bottom: "-" + pxToRem(primaryBorderWidth * 2),
                    left: "-" + pxToRem(primaryBorderWidth * 2),
                    borderWidth: "" + pxToRem(primaryBorderWidth),
                    borderStyle: 'solid',
                    borderColor: "" + primaryBorderColorFocusIndicator,
                    borderRadius: '3px',
                },
            },
        }), (isFromKeyboard &&
            circular && {
            ':focus': {
                color: primaryColorFocus,
                backgroundColor: primaryBackgroundColorFocus,
                borderColor: primaryBackgroundColorFocus,
                ':after': {
                    content: '""',
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    bottom: '0',
                    left: '0',
                    borderWidth: "" + pxToRem(primaryBorderWidth),
                    borderStyle: 'solid',
                    borderColor: "" + primaryCircularBorderColorFocusIndicator,
                    borderRadius: circularRadius,
                },
            },
        }), (!isFromKeyboard && {
            ':focus': {
                ':active': {
                    color: primaryColorActive,
                    backgroundColor: primaryBackgroundColorActive,
                    borderColor: primaryBorderColorActive,
                    boxShadow: 'none',
                },
            },
        }))), (disabled && {
            cursor: 'default',
            color: colorDisabled,
            backgroundColor: backgroundColorDisabled,
            borderColor: borderColorDisabled,
            boxShadow: 'none',
            ':hover': {
                backgroundColor: backgroundColorDisabled,
                borderColor: borderColorDisabled,
            },
        }), (fluid && {
            width: '100%',
            maxWidth: '100%',
        }), (iconOnly && {
            minWidth: height,
            padding: 0,
        }));
    },
    content: function () { return (__assign({}, truncateStyle)); },
};
export default buttonStyles;
